import http from "../http-common";

const GetAllResources = async (officeId) => {
  const events = await http.get(`/resources/${officeId}`).then((response) => {
    return response.data;
  });
  return events;
};

const PostResource = async (newData, officeId) => {
  const auth = await http
    .post(`/resources/${officeId}`, [newData])
    .then((response) => {
      return response.data;
    });
  return auth;
};

const DeleteResource = async (id) => {
  const deletedData = await http.delete(`/resources/${id}`).then((response) => {
    return response.data;
  });
  return deletedData;
};

const UpdateResource = async (id, newData) => {
  const updatedData = await http
    .put(`/resources/${id}`, newData)
    .then((response) => {
      return response.data;
    });
  return updatedData;
};

const GetAllResourcesOfVisit = async (id) => {
  const resources = await http.get(`/visitResources/${id}`).then((response) => {
    return response.data;
  });
  return resources;
};

const ResourcesAPI = {
  GetAllResources,
  PostResource,
  DeleteResource,
  UpdateResource,
  GetAllResourcesOfVisit,
};
export default ResourcesAPI;
